var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-link-wrap"},[_c('p',{staticClass:"text-link-open",style:({textAlign:_vm.formItem.align||'left',color:_vm.formItem.color,padding:_vm.formItem.padding||0}),on:{"click":_vm.goLink}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }